import createReactComponent from '../createReactComponent';
export default createReactComponent('circle-half', 'CircleHalf', [["path",{"d":"M12 21a9 9 0 1 0 0-18m0 18a9 9 0 1 1 0-18m0 18V3","key":"svg-0"}]]);